import React from 'react'
import moment from 'moment'
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import './../assets/table.css'
import TicketVerification from './TicketVerification'
import ascendIcon from '../images/ascendingIcon.svg'
import descendIcon from '../images/descendingIcon.svg'
import pointsIcon from '../images/3pointsIcon.svg'
import toCheckGroupIcon from '../images/toCheckGroupIcon.svg'
import lockIcon from '../images/lockIcon.svg'
import greyLikeIcon from '../images/greyLikeIcon.svg'
import greyOffenseIcon from '../images/greyOffenseIcon.svg'
import enabledCheckEventIcon from '../images/enabledCheckEventIcon.svg'
import editIcon from '../images/editIcon.svg'
import deleteIcon from '../images/deleteIcon.svg'
import _ from 'lodash'
import LinesEllipsis from 'react-lines-ellipsis'
import Popover from './Popover'
import Modal from 'react-responsive-modal'
import CircularProgress from '@material-ui/core/CircularProgress'
moment.locale('fr')

class TicketListContentByVehicleComponent extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      value: '',
      dataFilter: null,
      numHoverInitial: null,
      numHoverPop: null,
      openModal: false,
      idSelected: null,
      dataOfSelectedId: null,
      trbImm: null,
      data: props.data
    }
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.data !== this.props.data) {
      this.setState({
        dataFilter: null,
        data: nextProps.data
      })
    }
  }

  getSort (key) {
    const self = this
    const columnState = !self.state[key]
    this.setState({
      [key]: columnState,
      dataFilter: _.orderBy(
        self.state.data,
        [key],
        columnState ? 'asc' : 'desc'
      ),
      value: key
    })
  }

  onCloseModal () {
    const self = this
    self.setState({
      openModal: false
    })
  }

  popoverOpen (key) {
    this.setState({
      numHoverInitial: `${key}_initial}`,
      numHoverPop: `${key}_pop}`
    })
  }

  popoverClose () {
    this.setState({
      numHoverInitial: null,
      numHoverPop: null
    })
  }

  getHeader () {
    return (
      <Thead style={styles.theadStyle}>
        <Tr>
          <Th height='48px'
            style={styles.thLeft}
            onClick={
              () => this.getSort('date_time')
            }
          >
            <span>Date</span>
            <span className='transparent'>
              {
                this.state.value === 'date_time'
                  ? (this.state.date_time === true
                    ? <img
                      style={styles.imgStyle}
                      src={ascendIcon}
                      alt='true'
                    />
                    : <img
                      style={styles.imgStyle}
                      src={descendIcon}
                      alt='true'
                    />)
                  : <img
                    style={styles.imgStyle}
                    src={descendIcon}
                    alt='true'
                  />
              }
            </span>
          </Th>
          <Th
            style={styles.th}
            onClick={
              () => this.getSort('vehicle_number')
            }
          >
            <span>Camion</span>
            <span className='transparent'>
              { this.state.value === 'vehicle_number'
                ? (this.state.vehicle_number === true
                  ? <img
                    style={styles.imgStyle}
                    src={ascendIcon}
                    alt='true'
                  />
                  : <img
                    style={styles.imgStyle}
                    src={descendIcon}
                    alt='true'
                  />)
                : <img
                  style={styles.imgStyle}
                  src={descendIcon}
                  alt='true'
                />
              }
            </span>
          </Th>
          <Th
            style={styles.thStation}
            onClick={
              () => this.getSort('sale_point')
            }
          >
            <span>Station service</span>
            <span className='transparent'>
              { this.state.value === 'sale_point'
                ? (this.state.sale_point === true
                  ? <img
                    style={styles.imgStyle}
                    src={ascendIcon}
                    alt='true'
                  />
                  : <img
                    style={styles.imgStyle}
                    src={descendIcon}
                    alt='true'
                  />)
                : <img
                  style={styles.imgStyle}
                  src={descendIcon}
                  alt='true'
                />
              }
            </span>
          </Th>
          <Th
            style={styles.th}
            onClick={
              () => this.getSort('card')
            }
          >
            <span>Carte</span>
            <span className='transparent'>
              { this.state.value === 'card'
                ? (this.state.card === true
                  ? <img
                    style={styles.imgStyle}
                    src={ascendIcon}
                    alt='true'
                  />
                  : <img
                    style={styles.imgStyle}
                    src={descendIcon}
                    alt='true'
                  />)
                : <img
                  style={styles.imgStyle}
                  src={descendIcon}
                  alt='true'
                />
              }
            </span>
          </Th>
          <Th
            style={styles.th}
            onClick={
              () => this.getSort('driver_name')
            }
          >
            <span>Conducteur</span>
            <span className='transparent'>
              { this.state.value === 'driver_name'
                ? (this.state.driver_name === true
                  ? <img
                    style={styles.imgStyle}
                    src={ascendIcon}
                    alt='true'
                  />
                  : <img
                    style={styles.imgStyle}
                    src={descendIcon}
                    alt='true'
                  />)
                : <img
                  style={styles.imgStyle}
                  src={descendIcon}
                  alt='true'
                />
              }
            </span>
          </Th>
          <Th
            style={styles.th}
            onClick={
              () => this.getSort('service')
            }
          >
            <span>Produit</span>
            <span className='transparent'>
              { this.state.value === 'service'
                ? (this.state.service === true
                  ? <img
                    style={styles.imgStyle}
                    src={ascendIcon}
                    alt='true'
                  />
                  : <img
                    style={styles.imgStyle}
                    src={descendIcon}
                    alt='true'
                  />)
                : <img
                  style={styles.imgStyle}
                  src={descendIcon}
                  alt='true'
                />
              }
            </span>
          </Th>
          <Th
            style={styles.th}
            onClick={
              () => this.getSort('unit_price_client')
            }
          >
            <span>PU/litre</span>
            <span className='transparent'>
              { this.state.value === 'unit_price_client'
                ? (this.state.unit_price_client === true
                  ? <img
                    style={styles.imgStyle}
                    src={ascendIcon}
                    alt='true'
                  />
                  : <img
                    style={styles.imgStyle}
                    src={descendIcon}
                    alt='true'
                  />)
                : <img
                  style={styles.imgStyle}
                  src={descendIcon}
                  alt='true'
                />
              }
            </span>
          </Th>
          <Th
            style={styles.th}
            onClick={
              () => this.getSort('quantity')
            }
          >
            <span>Volume</span>
            <span className='transparent'>
              { this.state.value === 'quantity'
                ? (this.state.quantity === true
                  ? <img
                    style={styles.imgStyle}
                    src={ascendIcon}
                    alt='true'
                  />
                  : <img
                    style={styles.imgStyle}
                    src={descendIcon}
                    alt='true'
                  />)
                : <img
                  style={styles.imgStyle}
                  src={descendIcon}
                  alt='true'
                />
              }
            </span>
          </Th>
          <Th
            style={styles.th}
            onClick={
              () => this.getSort('cost_client')
            }
          >
            <span>Montant</span>
            <span className='transparent'>
              { this.state.value === 'cost_client'
                ? (this.state.cost_client === true
                  ? <img
                    style={styles.imgStyle}
                    src={ascendIcon}
                    alt='true'
                  />
                  : <img
                    style={styles.imgStyle}
                    src={descendIcon}
                    alt='true'
                  />)
                : <img
                  style={styles.imgStyle}
                  src={descendIcon}
                  alt='true'
                />
              }
            </span>
          </Th>
          <Th
            style={styles.th}
            onClick={
              () => this.getSort('event')
            }
          >
            <span>Evenements</span>
            <span className='transparent'>
              { this.state.value === 'event'
                ? (this.state.event === true
                  ? <img
                    style={styles.imgStyle}
                    src={ascendIcon}
                    alt='true'
                  />
                  : <img
                    style={styles.imgStyle}
                    src={descendIcon}
                    alt='true'
                  />)
                : <img
                  style={styles.imgStyle}
                  src={descendIcon}
                  alt='true'
                />
              }
            </span>
          </Th>
          <Th
            style={styles.thRight}
            onClick={
              () => this.getSort('state')
            }
          >
            <span>Etat</span>
            <span className='transparent'>
              { this.state.value === 'state'
                ? (this.state.state === true
                  ? <img
                    style={styles.imgStyle}
                    src={ascendIcon}
                    alt='true'
                  />
                  : <img
                    style={styles.imgStyle}
                    src={descendIcon}
                    alt='true'
                  />)
                : <img
                  style={styles.imgStyle}
                  src={descendIcon}
                  alt='true'
                />
              }
            </span>
          </Th>
        </Tr>
      </Thead>
    )
  }

  getStateValue (checked, state) {
    if (!checked && state === '') {
      return (
        <div>
          <span style={{ height: 15 }}>En cours</span><br />
        </div>
      )
    }
    if (!checked && state === 'to_check') {
      return (
        <div>
          <span style={{ height: 15 }}>A vérifier</span><br />
          <img
            style={styles.iconBottom}
            src={toCheckGroupIcon}
            alt='true'
          />
        </div>
      )
    }
    if (checked && state === 'valid') {
      return (
        <div>
          <img
            src={greyLikeIcon}
            alt='true'
            height='15'
          /><br />
          <img
            style={styles.iconBottom}
            src={lockIcon}
            alt='true'
          />
        </div>
      )
    }
    if (checked && state === 'invalid') {
      return (
        <div>
          <img
            src={greyOffenseIcon}
            alt='true'
            height='15'
          /><br />
          <img
            style={styles.iconBottom}
            src={lockIcon}
            alt='true'
          />
        </div>
      )
    }
  }

  onClickRow (id, state, trbImm) {
    const self = this
    if (state === 'to_check') {
      self.setState({
        openModal: true,
        trbImm: trbImm,
        idSelected: id
      })
    }
  }

  getBody (data) {
    const self = this
    data = self.state.dataFilter ? self.state.dataFilter : data
    return (
      <Tbody style={styles.tbodyStyle}>
        {data.map((value, key) => {
          return (
            <Tr
              style={{ cursor: (!value.checked && value.state === 'to_check') ? 'pointer' : null }}
              key={key}
              onMouseEnter={
                () => self.popoverOpen(key)
              }
              onMouseLeave={
                () => self.popoverClose()
              }
              onClick={() => self.onClickRow(value._id, value.state, value.vehicle_number)}
            >
              <Td className='tdDateAndTime'>
                <span
                  className='marginHour'>{moment(value.date_time).format('DD/MM/YYYY')}
                </span><br />
                <span
                  className='marginHour'>{moment(value.date_time).format('HH:mm')}
                </span>
              </Td>
              <Td><span>{value.vehicle_number}</span></Td>
              <Td>
                <span>
                  <LinesEllipsis
                    text={value.sale_point}
                    maxLine='1'
                    ellipsis='...'
                    trimRight
                    basedOn='letters'
                  />
                </span>
              </Td>
              <Td><span>{value.card}</span></Td>
              <Td><span>{value.driver_name}</span></Td>
              <Td><span>{value.service}</span></Td>
              <Td><span>{value.unit_price_client}</span></Td>
              <Td><span>{value.quantity} Litres</span></Td>
              <Td><span>{value.cost_client}</span></Td>
              <Td><span>{value.has_event ? 'Oui' : 'Non'}</span></Td>
              <Td className='tdRight'>
                <div style={styles.contentRight}>
                  <span>
                    {self.getStateValue(value.checked, value.state)}
                  </span>
                  {value.state === ''
                    ? <Popover
                      keys={key}
                      implementPop={true}
                      numHoverInitial={self.state.numHoverInitial}
                      numHoverPop={self.state.numHoverPop}
                      iconInitial={pointsIcon}
                      iconPopLeft={editIcon}
                      iconPopCenter={enabledCheckEventIcon}
                      iconPopRight={deleteIcon}
                      onClickLeftButton={() => self.props.onClickLeftButton(value._id)}
                      onClickButtonCenter={() => self.props.onClickButtonCenter(value._id)}
                      onClickButtonRight={() => self.props.onClickButtonRight(value._id)}
                      leftLabel='Editer'
                      centerLabel='Vérifier'
                      rightLabel='Supprimer'
                    /> : null}
                </div>
              </Td>
            </Tr>
          )
        })}
      </Tbody>
    )
  }

  render () {
    if (!this.state.data) {
      return <CircularProgress style={{ color: '#7ED321', marginTop: '50px' }} color='inherit' />
    }
    return (
      <div style={styles.paper}>
        <div style={styles.content}>
          <div className='ticketTableContent'>
            <Table cellSpacing='0' cellPadding='0' style={styles.tableStyle}>
              {this.getHeader()}
              {this.getBody(this.state.data)}
            </Table>
            <div>
              <Modal
                styles={bg}
                open={this.props.openModal}
                onClose={this.props.onCloseModal}
                showCloseIcon={false}
                focusTrapped={false}>
                <h2 style={styles.modalTitle}>Supprimer un ticket</h2>
                <p style={styles.modalText}>
                  Voulez vous  vraiment supprimer ce ticket ?
                </p>
                <div>
                  <button style={styles.modalButtonLeft} onClick={this.props.onCloseModal}><span>Annuler</span></button>
                  <button style={styles.modalButtonRight} onClick={this.props.confirmSuppressionTicket}>Supprimer</button>
                </div>
              </Modal>
            </div>
            <div>
              <Modal
                styles={bgVerification}
                open={this.state.openModal}
                onClose={() => this.onCloseModal()}
                showCloseIcon={false}
                center
                focusTrapped={false}>
                <TicketVerification
                  onClose={() => this.onCloseModal()}
                  selectedTicketId={this.state.idSelected}
                  trbImm={this.state.trbImm}
                />
              </Modal>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const bg = {
  modal: {
    background: '#364248',
    borderRadius: '6px',
    color: '#F2F2F2'
  }
}

const bgVerification = {
  modal: {
    background: '#15191C',
    maxWidth: '1400px',
    overflowX: 'auto'
  }
}

const styles = {
  paper: {
    height: '100vh'
  },
  content: {
    width: '100%',
    overflowY: 'auto',
    overflowX: 'auto',
    height: 'auto',
    maxHeight: '100vh',
    paddingRight: '10px'
  },
  tableStyle: {
    width: '100%',
    marginTop: '-12px',
    borderSpacing: '0px 12px'
  },
  theadStyle: {
    fontSize: '14px',
    textAlign: 'left',
    color: '#F2F2F2'
  },
  thLeft: {
    cursor: 'pointer',
    width: '9%',
    marginLeft: '15px'
  },
  th: {
    cursor: 'pointer',
    width: '9%'
  },
  thStation: {
    cursor: 'pointer',
    width: '10%'
  },
  thRight: {
    cursor: 'pointer',
    width: '9%',
    textAlign: 'right',
    paddingRight: '15px'
  },
  tbodyStyle: {
    fontSize: '14px',
    height: '80px',
    textAlign: 'left',
    color: '#F2F2F2'
  },
  spanVolumes: {
    color: '#7ED321'
  },
  contentRight: {
    marginRight: '15px'
  },
  imgStyle: {
    marginLeft: '20px'
  },
  iconStyle: {
    width: '20px',
    height: '20px'
  },
  transparent: {
    width: '20px',
    height: '20px',
    color: 'transparent'
  },
  iconBottom: {
    marginTop: '7px',
    height: '14px'
  },
  modalTitle: {
    marginTop: '-10px',
    textAlign: 'center'
  },
  modalText: {
    fontSize: '12px'
  },
  modalButtonLeft: {
    float: 'left',
    width: '100px',
    borderWidth: '0px',
    height: '24px',
    borderRadius: '3px'
  },
  modalButtonRight: {
    backgroundColor: '#FB0040',
    borderWidth: '0px',
    float: 'right',
    width: '100px',
    height: '24px',
    borderRadius: '3px'
  }
}

export default TicketListContentByVehicleComponent
